import { IFinance, FamilySponsorshipMap, OtherSponsorshipMap } from 'types';

export function getInvalidFundingSources(fin: IFinance): [FamilySponsorshipMap, OtherSponsorshipMap] {
  const familySponsorship = fin.familySponsorship ?? {};
  const invalidFamilySponsorship = Object.keys(familySponsorship)
    .filter(key => familySponsorship[key].accountType === 'Other')
    .reduce((obj: FamilySponsorshipMap, key) => {
      obj[key] = familySponsorship[key];
      return obj;
    }, {});

  const invalidOtherSponsorship = fin.otherSponsorship ?? {};

  return [invalidFamilySponsorship, invalidOtherSponsorship];
}
